import { useNavigate } from 'react-router-dom'
import { Gauge, ArrowRight, FileText } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Card, CardContent } from '@/components/ui/card'

const features = [
  {
    id: 'zaehler',
    icon: Gauge,
    title: 'Zaehler erfassen & pruefen',
    description: 'Elektrozaehler fotografieren und automatisch auslesen lassen. Seriennummer, Kennnummer und Wohnungsnummer werden erkannt.',
    path: '/admin/ki/zaehler',
  },
  {
    id: 'pdf-to-md',
    icon: FileText,
    title: 'PDF zu Markdown',
    description: 'PDF oder Scan hochladen, per OCR (PaddleOCR) in sauberes Markdown umwandeln und direkt kopieren oder als .md herunterladen. Datei wird nach Verarbeitung sofort gelöscht.',
    path: '/admin/ki/pdf-to-md',
  },
]

export default function KI() {
  const navigate = useNavigate()

  return (
    <div>
      <PageHeader
        title="K.I. Funktionen"
        description="Kuenstliche Intelligenz zur Unterstuetzung auf der Baustelle"
      />

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => (
          <Card
            key={feature.id}
            className="group cursor-pointer transition-all hover:shadow-lg"
            onClick={() => navigate(feature.path)}
          >
            <CardContent className="p-6">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 transition-transform group-hover:scale-110">
                <feature.icon className="h-6 w-6 text-primary-600" />
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="mb-4 text-sm text-muted-foreground">{feature.description}</p>
              <div className="flex items-center text-sm font-medium text-primary-600 transition-all group-hover:gap-2">
                <span>Oeffnen</span>
                <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
